import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { TermsAndConditionsStep } from 'member-portal/components'
import { AccountType, MembershipType } from 'types'
import { makeMembershipIdPath, PATH } from 'config'

const propTypes = {
  account: AccountType.isRequired,
  membership: MembershipType.isRequired,
}

function RenewalTermsAndConditions({ account, membership }) {
  const { sfid: membershipId } = membership
  return (
    <TermsAndConditionsStep
      account={account}
      membership={membership}
      basePath={makeMembershipIdPath(
        membershipId,
        PATH.RENEW_MEMBERSHIP,
        PATH.TERMS_AND_CONDITIONS,
      )}
      nextStep={makeMembershipIdPath(
        membershipId,
        PATH.RENEW_MEMBERSHIP,
        PATH.PAYMENT,
      )}
    />
  )
}

RenewalTermsAndConditions.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: memberSelectors.account(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  RenewalTermsAndConditions,
)
